import { FlexBox, Typography, Button, Icon, Box } from '@vp/swan';
import React, { useContext, useState, useEffect } from 'react';
import './src-components-MessageFeedback-MessageFeedback.styles.scss.js';
import { useCustomTracking } from './src-hooks-custom-hooks-useTracking.js';
import { CAContext } from './src-contexts-CAContext.js';
import FeedbackPopover from './src-components-MessageFeedback-FeedbackPopover.js';

const MessageFeedback = ({ bubbleWidth, messageId }) => {
  const {
    chatState: { scrollToBottom }
  } = useContext(CAContext);
  const { sendTrackingEvent } = useCustomTracking();
  const [displayText, setDisplayText] = useState("Good answer?");
  const [showPopover, setShowPopover] = useState(false);
  const [activeButton, setActiveButton] = useState(null);
  const handleSendFeedback = (feedbackMessage) => {
    sendTrackingEvent("Chatbot Clicked", "Chatbot:Feedback", "botFeedbackSubmitted", void 0, { feedbackText: feedbackMessage, messageId, reaction: "down" });
    setShowPopover(false);
    setDisplayText("Thanks!");
  };
  const handleLike = () => {
    setDisplayText("Thanks!");
    setShowPopover(false);
    setActiveButton("like");
    sendTrackingEvent("Chatbot Clicked", "Chatbot:Feedback", "botFeedbackReaction", void 0, { messageId, reaction: "up" });
  };
  const handleDislike = () => {
    setShowPopover(true);
    setDisplayText("Tell us why:");
    setActiveButton("dislike");
    sendTrackingEvent("Chatbot Clicked", "Chatbot:Feedback", "botFeedbackReaction", void 0, { messageId, reaction: "down" });
  };
  const handleClosePopover = () => {
    setShowPopover(false);
    setDisplayText("Thanks!");
  };
  useEffect(() => {
    if (showPopover) {
      sendTrackingEvent("Chatbot Viewed", "Chatbot:Feedback", "botFeedbackTextOpened", void 0, { messageId });
      scrollToBottom?.(`feedback-popover-${messageId}`);
    }
  }, [showPopover]);
  const [isInitialEventSent, setIsInitialEventSent] = useState(false);
  useEffect(() => {
    if (!isInitialEventSent) {
      sendTrackingEvent("Chatbot Viewed", "Chatbot:Feedback", "botFeedbackPromptShown", void 0, { messageId });
      setIsInitialEventSent(true);
    }
  }, [isInitialEventSent]);
  return /* @__PURE__ */ React.createElement(FlexBox, { flexDirection: "column", compactMode: true, marginTop: 2 }, /* @__PURE__ */ React.createElement(FlexBox, { style: { width: `${bubbleWidth + 20}px` }, gap: "between-actions", compactMode: true, justifyContent: "flex-end" }, /* @__PURE__ */ React.createElement(Typography, { fontSkin: "body-small", textColor: "subtle", style: { alignContent: "center" }, className: "message-feedback-text", key: displayText }, displayText), /* @__PURE__ */ React.createElement(FlexBox, { gap: "0" }, /* @__PURE__ */ React.createElement(Button, { onClick: handleLike, className: `message-feedback-button ${activeButton === "like" ? "active" : ""}`, padding: 4 }, /* @__PURE__ */ React.createElement(Icon, { iconType: "like", size: "20p" })), /* @__PURE__ */ React.createElement(Button, { className: `message-feedback-button ${activeButton === "dislike" ? "active" : ""}`, onClick: handleDislike, padding: 4 }, /* @__PURE__ */ React.createElement(Icon, { iconType: "dislike", size: "20p" })))), /* @__PURE__ */ React.createElement(FlexBox, null, showPopover && /* @__PURE__ */ React.createElement(Box, { className: "message-feedback-popover", padding: 5, marginTop: 3, mx: 5, compactMode: true }, /* @__PURE__ */ React.createElement(FeedbackPopover, { onClose: handleClosePopover, onSendFeedback: handleSendFeedback, id: `feedback-popover-${messageId}` }), " ")));
};

export { MessageFeedback as default };
//# sourceMappingURL=src-components-MessageFeedback-MessageFeedback.js.map
